export default __webpack_public_path__ + "static/media/AcidGasInjection1.4a09db8f.png";